<template>
    <div>
        <b-modal id="modalMilimetragem" data-backdrop="static" data-keyboard="false" centered
            :title="this.$t('Pneus a Placa:') + ' - ' + nr_placa.nr_placa">

            <div id="globalAfericoes">
                <div id="veiculoPneus" class="veiculo-fixo text-center scalable">
                    <div class="chassi"></div>
                </div>

                <div id="selectPneusBD" class="container text-center">
                    <p>{{ $t('Informe o KM do Pneu') }}:</p>
                    <input type="number" class="form-control mb-2" v-model="km_informado">

                    <p>{{ $t('Selecione um Pneu') }}:</p>
                    <v-select class="mb-3" id="select_pneu" :options="pneusBD" @input="fogo_pneu = $event" v-model="model_select_pneu ">
                    </v-select> 
                    <div class="col-12">
                        <button class="btn btn-success" @click="inserePneu">{{ $t('Confirmar') }}</button>
                    </div>
                </div>
            </div>

            <modal-registra-troca-pneu refs="registraTrocaPneu" :pneu="informacaoPneu" v-if="showRemovePneu"
                :afericoesFeitas="arrayAfericoes" :veiculo="veiculo" @refreshCaminhao="refreshCaminhao"
                @closeModal="modalShow = false" @adicionarAfericao="adicionarAfericao"> </modal-registra-troca-pneu>

            <template #modal-footer="{ cancel }">
                <div class="w-100">
                    <div class="row center" style="justify-content: center;">
                        <b-button class="mr-2" variant="danger" size="lg" @click="cancel(), modalShow = false">
                            {{ $t('Fechar') }}
                        </b-button>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import ModalRegistraTrocaPneu from './ModalRegistraTrocaPneu.vue';

export default {
    name: "ModalExterna",
    props: {
        nr_placa: {}
    },
    components: {
        ModalRegistraTrocaPneu
    },

    data() {
        return {
            arrayAfericoes: [],
            informacaoPneu: '',
            modalShow: false,
            submitAfericao: [],
            disabledFinalizar: false,
            km_informado: '',
            showBtnFinalizar: true,
            showSelectPneu: false,
            pneuTemp: '',
            showRemovePneu: false,
            fogo_pneu: '',
            valida_km: '',
            model_select_pneu: ''
        };
    },

    computed: {
        veiculo() {
            return this.$store.getters['borracharia/getVeiculo']
        },
        pneus() {
            return this.$store.getters['borracharia/getAfericao']
        },
        pneusBD() {
            // this.$store.dispatch('borracharia/getPneusBD')
            const pneus = this.$store.getters['borracharia/getPneusBD']

            if(!pneus) {
                this.$store.dispatch('borracharia/getPneusBD')
                return []
            }
            console.log(pneus)
            // return ''
            return pneus.map(pneu => {
                return {
                    ...pneu,
                    label: pneu.nr_fogo
                }
            })
        }
    },

    methods: {
        adicionarAfericao(afericao) {
            this.modalShow = false
            // this.showBtnFinalizar = !this.modalShow

            if (localStorage.afericao == undefined) {
                const dataInicio = {
                    nr_placa: 'AAA000',
                    afericoes: []
                }
                localStorage.setItem('afericao', JSON.stringify(dataInicio));
            }

            const localAfericao = JSON.parse(localStorage.afericao)

            if (this.nr_placa.nr_placa == localAfericao.nr_placa) {
                this.submitAfericao = localAfericao.afericoes
            } else {
                this.submitAfericao = []
            }

            var indice = this.submitAfericao.findIndex(function (item) {
                if (item.nr_fogo) {
                    return item.nr_fogo === afericao.nr_fogo;
                }

                return -1
            });

            if (indice !== -1) {
                this.submitAfericao[indice] = afericao;
            } else {
                this.submitAfericao.push(afericao);
            }

            const todosPneus = document.querySelectorAll('.pneu-fixo')

            this.submitAfericao.forEach(function (afe) {
                todosPneus.forEach((pneu) => {

                    if (pneu.innerText == afe.nr_fogo) {
                        pneu.classList.add('pneuSelecionadoAfericao')
                    }
                })
            })

            const data = {
                nr_placa: this.nr_placa.nr_placa,
                afericoes: this.submitAfericao
            }

            localStorage.afericao = JSON.stringify(data)

            if (data.afericoes.length === todosPneus.length) {
                this.disabledFinalizar = false
            }
            this.adicionarClassePneu()
        },
 
        gerarCaminhao() {
            this.$store.dispatch('borracharia/getPneusBD')

            document.getElementById('selectPneusBD').style.display = 'none'
            let pneus = this.pneus

            for (let i = 1; i <= pneus.length; i++) {
                this.$nextTick(() => {
                    if (pneus[i]) {
                        var divChassi = document.createElement('div')

                        divChassi.classList.add(`eixo`)
                        if (pneus[i - 1].ds_lado == 'EEE') {
                            divChassi.classList.add(`eixo-estepe-1`)
                        } else {
                            divChassi.classList.add(`eixo-${pneus[i - 1].nr_posicao}`)
                        }
                        // console.log(pneus[i].eixo_direcional)
                        
                        if(pneus[i - 1].eixo_direcional){
                            divChassi.classList.add(`eixo-direcional-${pneus[i - 1].nr_posicao}`)
                        }

                        let divPai = document.getElementById('veiculoPneus')
                        divPai.classList.add(`margin-afericao-${pneus[i - 1].nr_posicao}`)

                        divPai.appendChild(divChassi)
                    }

                    // document.getElementById('chassi').style.width = `${pneus.length}00 px;`
                })
            }

            let divChassi = document.querySelector('.chassi')
            let contador_step = 0
            let contador_direcional = 1

            pneus.forEach((pneu, index) => {
                let divPneu = document.createElement('span')
                let btnAcaoPneu = document.createElement('b-button')

                let acaoBtn = 'remove'
                btnAcaoPneu.classList.add('btn-danger')
                btnAcaoPneu.classList.add('btnRemover')
                btnAcaoPneu.innerText = '-'

                if (pneu.nr_fogo == null) {
                    btnAcaoPneu.classList.remove('btn-danger')
                    btnAcaoPneu.classList.add('btn-success')
                    btnAcaoPneu.innerText = '+'
                    acaoBtn = 'insere'
                }

                divPneu.innerText = pneu.nr_fogo
                divPneu.value = pneu.vl_mm

                divPneu.classList.add(`pneu-fixo`)
                divPneu.classList.add(`coluna-${pneu.nr_posicao}`)
                
                divChassi.classList.remove(`chassi-${pneu.nr_posicao}`)
                divChassi.classList.add(`chassi-${pneu.nr_posicao}`)
 
                if(pneu.eixo_direcional) {
                    contador_direcional = contador_direcional + 1
                    divPneu.classList.add(`pneu-direcional-${contador_direcional}`)
                    divChassi.classList.add(`chassi-direcional-${index}`)
                }

                if(pneu.ds_lado == 'EEE') {
                    console.log(pneu.nr_posicao)

                    contador_step = contador_step + 1
                    divPneu.classList.add(`step-${contador_step}`)
                    divPneu.classList.add(`step-1`)
                    divChassi.classList.remove(`chassi-${pneu.nr_posicao}`)
                }

                if(pneu.ds_lado == 'EEE') {
                    console.log(pneu.nr_posicao)
                    contador_step = contador_step >= 4 ? 4 : contador_step
                    contador_step = contador_step + 1
                    divPneu.classList.add(`step-${contador_step}`)
                    divPneu.classList.add(`step-1`)
                    divChassi.classList.remove(`chassi-${pneu.nr_posicao}`)
                }

                if (pneu.ds_lado == "EE") {
                    divPneu.classList.add('externo-esquerdo')
                } else if (pneu.ds_lado == "EI") {
                    divPneu.classList.add('interno-esquerdo')
                } else if (pneu.ds_lado == "DE") {
                    divPneu.classList.add('externo-direito')
                } else if (pneu.ds_lado == "DI") {
                    divPneu.classList.add('interno-direito')
                }

                let divPai = document.getElementById('veiculoPneus')
                divPneu.appendChild(btnAcaoPneu)
                divPai.appendChild(divPneu)

                divPneu.addEventListener('click', () => {
                    if (acaoBtn == 'remove') {
                        this.removePneu(pneu)
                    } else {
                        this.exibeSelectPneus()
                        this.pneuTemp = pneu
                    }

                })
            })

        },

        // adicionaStep(){
            
        // },

        removePneu(pneu) {
            console.log('Remove o Pneu')
            console.log(pneu)
            console.log(this.showRemovePneu)
            this.showRemovePneu = true
            this.informacaoPneu = pneu
            const arrayAfericoesTemp = pneu.vl_mm.split('|')
            // this.$refs.registraTrocaPneu.populaArrayAfericao()

            this.arrayAfericoes = arrayAfericoesTemp.map(function (string, indice) {
                return { indice: indice, valor: string };
            });
            
                

            // this.$swal.fire({
            //     title: "Confirmação?",
            //     text: `Você deseja remover o pneu ${pneu.nr_fogo} deste veículo?`,
            //     icon: "warning",
            //     showCancelButton: true,
            //     confirmButtonColor: "#3085d6",
            //     cancelButtonColor: "#d33",
            //     confirmButtonText: "Sim, remover!",
            //     reverseButtons: true

            // }).then((result) => {
            //     if (result.dismiss !== 'cancel' && result.dismiss !== 'backdrop') {

            //         this.$store.dispatch('borracharia/removerPneu', { data: pneu }).then(response => {
            //             this.$swal.fire({
            //                 title: "Removido!",
            //                 text: "Pneu removido com sucesso.",
            //                 icon: "success"
            //             });
            //         }).catch(() => {
            //             this.$swal.fire({
            //                 title: "Oops!",
            //                 text: "Erro ao remover o pneu.",
            //                 icon: "error"
            //             });
            //         })

            //         this.refreshCaminhao()
            //     }

            //     // const data = {
            //     //     nr_placa: this.nr_placa.nr_placa
            //     // }
            //     // this.$emit('refreshCaminhao', { placa: this.veiculo.nr_placa })
            //     // this.$store.dispatch('borracharia/getPlacaMilimetragem', { data: data })
            //     // this.gerarCaminhao()
            // })
        },

        refreshCaminhao() {
            const data = this.$store.getters['borracharia/getParams']
            console.log(data)
            this.$store.dispatch('borracharia/getPlacaMovimentacoes', { data: data }).then(() => {
                this.gerarCaminhao()
                this.adicionarAcao()
                this.adicionarClassePneu()
                this.placa = data
                this.$store.dispatch('borracharia/getPneusBD')
            })
        },

        exibeSelectPneus() {
            this.model_select_pneu = ''
            document.getElementById('selectPneusBD').style.display = 'initial'
            
            this.$store.dispatch('borracharia/getPneusBD')
            
        },

        inserePneu() {
            if (this.km_informado < this.valida_km) {
                this.$swal.fire({
                    title: this.$t('Oops!'),
                    text: this.$t('Insira um KM maior que o anterior'),
                    icon: 'warning'
                })
                return false
            }


            const data = {
                pneu: this.fogo_pneu,
                placa: this.nr_placa.nr_placa,
                ds_lado: this.pneuTemp,
                km_informado: this.km_informado
            }

            this.$store.dispatch('borracharia/inserePneu', { data: data }).then(response => {
                if (response.data.insert_pneu_mm && response.data.insert_veiculos_pneus && response.data.veiculos_pneus) {
                    this.$swal.fire({
                        title: this.$t('Sucesso!'),
                        text: this.$t('Pneu vinculado com sucesso!'),
                        icon: 'success',
                        time: 1500
                    })

                }
                this.$store.dispatch('borracharia/getPneusBD')

                document.getElementById('selectPneusBD').style.display = 'none'
                this.refreshCaminhao()
            }) 
        },

        adicionarClassePneu() {
            this.km_informado = parseInt(this.veiculo.km_atual)
            this.valida_km = parseInt(this.veiculo.km_atual)
            this.showRemovePneu = false
            const todosPneus = document.querySelectorAll('.pneu-fixo')

            let aferTemp = {}

            if (localStorage.afericao != undefined) {
                aferTemp = JSON.parse(localStorage.afericao)

                todosPneus.forEach((pneu) => {
                    aferTemp.afericoes.forEach(function (afe) {
                        if (pneu.innerText == afe.nr_fogo) {
                            pneu.classList.add('pneuSelecionadoAfericao')
                        }
                    })
                })
            }
        },

        adicionarAcao() {
            // const pneusRemover = document.querySelectorAll('.btnRemover')

            // pneusRemover.forEach(acaoPneu => {
            //     acaoPneu.addEventListener('click', () => {
            //         console.log(acaoPneu)


            //     })
            // })
        },

    },
    created() {
        this.adicionarClassePneu()
    }
}
</script>

<style src="./style.css" />
